import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Coffee, Mail } from 'lucide-react';
import api from '../../utils/api';
import toast from 'react-hot-toast';
import './Auth.css';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
      toast.success('Reset link sent!');
    } catch (err) {
      toast.error('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo"><Coffee size={32} /><span>Brew & Co</span></div>
        <h2>Forgot Password</h2>
        {sent ? (
          <div className="auth-success">
            <Mail size={48} />
            <p>Check your email! We've sent a password reset link to <strong>{email}</strong>.</p>
            <Link to="/login" className="btn-primary" style={{ marginTop: 16 }}>Back to Sign In</Link>
          </div>
        ) : (
          <>
            <p className="auth-sub">Enter your email and we'll send you a reset link.</p>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Email Address</label>
                <input type="email" className="form-control" placeholder="you@example.com"
                  value={email} onChange={e => setEmail(e.target.value)} required />
              </div>
              <button type="submit" className="btn-gold auth-submit" disabled={loading}>
                {loading ? <span className="spinner" style={{ width: 20, height: 20, borderWidth: 2 }} /> : 'Send Reset Link'}
              </button>
            </form>
            <p className="auth-switch"><Link to="/login">← Back to Sign In</Link></p>
          </>
        )}
      </div>
    </div>
  );
}
